import axiosInstance from "../axiosInstance";

export const applicationsApi = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/ExternalData${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
        // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(
        `/ExternalData${path}`,
        { params },
        {
          cancelToken: cancelToken?.token,
          headers,
        }
      )
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

export const validateIban = async (id) =>
  applicationsApi.get(`/ValidateIBAN/${id}`);

export const validateHusbands = async (id) =>
  applicationsApi.get(`/ValidateHusbands/${id}`);

export const validateChildren = async (id) =>
  applicationsApi.get(`/ValidateChildren/${id}`);

export const validateChildrenIbans = async (id) =>
  applicationsApi.get(`/ValidateChildrenIBAN/${id}`)

export const customValidateIban = async (id, iban) =>
  applicationsApi.get(`/ValidateIBAN/${id}?iban=${iban}`);

export const generateAttachments = async (id, memberId = null, service = null) => {
  const params = new URLSearchParams();

  if (memberId) params.set("memberId", memberId);
  if (service) params.set("service", service);

  const query = params.toString();
  return applicationsApi.get(`/GenerateAttachments/${id}${query ? `?${query}` : ""}`);
};
